import { BaseResource } from './base';
import {
  CommissionCalculationDto,
  CommissionFiltersDto,
  CommissionSummaryDto,
  SimulateCommissionDto,
  CommissionSimulationDto,
} from '../models/commissions';
import { RequestOptions, PaginatedResponseDto } from '../types';

export class CommissionCalculationsResource extends BaseResource {
  private basePath = 'commissions/calculations';

  async createCalculation(
    data: { contractId: string; collaboratorId: string },
    options?: RequestOptions,
  ): Promise<CommissionCalculationDto> {
    return this.client.post<CommissionCalculationDto>(this.basePath, data, options);
  }

  async getCalculation(id: string, options?: RequestOptions): Promise<CommissionCalculationDto> {
    return this.client.get<CommissionCalculationDto>(`${this.basePath}/${id}`, undefined, options);
  }

  async getCalculations(
    params?: CommissionFiltersDto,
    options?: RequestOptions,
  ): Promise<PaginatedResponseDto<CommissionCalculationDto>> {
    return this.paginate<CommissionCalculationDto>(this.basePath, params, options);
  }

  async getCollaboratorCalculations(
    collaboratorId: string,
    params?: CommissionFiltersDto,
    options?: RequestOptions,
  ): Promise<PaginatedResponseDto<CommissionCalculationDto>> {
    return this.paginate<CommissionCalculationDto>(
      `${this.basePath}/collaborator/${collaboratorId}`,
      params,
      options,
    );
  }

  async confirmCalculation(
    id: string,
    data: { note?: string },
    options?: RequestOptions,
  ): Promise<CommissionCalculationDto> {
    return this.client.put<CommissionCalculationDto>(
      `${this.basePath}/${id}/confirm`,
      data,
      options,
    );
  }

  async reverseCalculation(
    id: string,
    data: { reason: string },
    options?: RequestOptions,
  ): Promise<CommissionCalculationDto> {
    return this.client.put<CommissionCalculationDto>(
      `${this.basePath}/${id}/reverse`,
      data,
      options,
    );
  }

  async markAsPaid(
    id: string,
    data: { paidDate: string; note?: string },
    options?: RequestOptions,
  ): Promise<CommissionCalculationDto> {
    return this.client.put<CommissionCalculationDto>(`${this.basePath}/${id}/paid`, data, options);
  }

  async simulate(
    data: SimulateCommissionDto,
    options?: RequestOptions,
  ): Promise<CommissionSimulationDto> {
    return this.client.post<CommissionSimulationDto>('commissions/simulator', data, options);
  }

  async getMyCommissions(
    params?: CommissionFiltersDto,
    options?: RequestOptions,
  ): Promise<PaginatedResponseDto<CommissionCalculationDto>> {
    return this.paginate<CommissionCalculationDto>('commissions/me', params, options);
  }

  async getMyCommissionsSummary(options?: RequestOptions): Promise<CommissionSummaryDto> {
    return this.client.get<CommissionSummaryDto>('commissions/me/summary', undefined, options);
  }
}
